module.exports = __webpack_public_path__ + "static/media/flexibility.efbcd4a4.jpg";